// extracted by mini-css-extract-plugin
export default {"avatarUpload":"AgentGeneralTab_avatarUpload__soT-s","avatarPreview":"AgentGeneralTab_avatarPreview__9r+Hi","uploadButton":"AgentGeneralTab_uploadButton__2059s"};